import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Div from '../Page/Div';
import { Link } from 'react-router-dom';
import React from 'react';
import { CARD_WIDTH_CSS_VAR } from '../Resizer';
import Stepper from '../Page/Stepper';
import { isMac, linkToText, MOBILE_SAFE_RESIZE } from '../globalUtils';
const CardSlider = ({ children, details, hasStepper, linkArrow, noGradient, startGap, isAllowed, }) => {
    const [, setRender] = useState(0);
    const activeCard = useRef(0);
    const centerCard = useRef(0);
    const mousePosition = useRef(null);
    const cardWidth = useRef(0);
    const containerWidth = useRef({
        x: 0,
        width: 0,
    });
    const scrollX = useRef(0);
    const detailsRef = useRef(null);
    const leftGradientRef = useRef(null);
    const sliderRef = useRef(null);
    const detailsButtonRef = useRef(null);
    const mounted = useRef(false);
    const allowNewScroll = useRef(true);
    const allowNewScrollTimeout = useRef(0);
    const onMouseAllow = () => {
        //prevDeltaY.current = 1000;
        mouseScrollCounter.current = 0;
        isMouse.current = false;
        //allowNewScroll.current = true;
    };
    useEffect(() => {
        isMouse.current = false;
    }, [isAllowed]);
    useEffect(() => {
        window.addEventListener(MOBILE_SAFE_RESIZE, onResize);
        setTimeout(() => onResize(), 10);
        if (leftGradientRef.current) {
            leftGradientRef.current.style.opacity = '0';
        }
        return () => {
            sliderRef.current?.removeEventListener('scroll', onScrollEvent);
            window.removeEventListener(MOBILE_SAFE_RESIZE, onResize);
        };
    }, []);
    const onResize = () => {
        containerWidth.current = sliderRef.current?.getBoundingClientRect() ?? {
            x: 0,
            width: 0,
        };
        scrollX.current = detailsRef.current?.scrollLeft ?? 0;
        const cssCardWidth = parseFloat(document.body.style.getPropertyValue(CARD_WIDTH_CSS_VAR) ?? '0');
        if (!Number.isNaN(cssCardWidth)) {
            cardWidth.current = cssCardWidth;
        }
    };
    const onSliderRef = (ref) => {
        if (sliderRef.current) {
            sliderRef.current.removeEventListener('scroll', onScrollEvent);
            sliderRef.current.removeEventListener('wheel', onWheelEvent);
        }
        sliderRef.current = ref;
        if (ref && sliderRef.current) {
            sliderRef.current.addEventListener('scroll', onScrollEvent);
            sliderRef.current.addEventListener('wheel', onWheelEvent, {
                passive: false,
            });
        }
    };
    const prevDeltaY = useRef(0);
    const deltaCounter = useRef(0);
    const newScrollRegister = useRef(false);
    const mouseScrollCounter = useRef(0);
    const isMouse = useRef(false);
    const isTrackPad = useRef(false);
    const MAX_MOUSE_SCROLL_COUNT = isMac ? 1 : 5;
    const onWheelEvent = (evt) => {
        if (!sliderRef.current)
            return;
        isTrackPad.current = evt.deltaMode === 0 && Math.abs(evt.deltaY) < 50;
        const isLeft = sliderRef.current.scrollLeft < 1 && evt.deltaY < 0;
        const bounds = sliderRef.current.getBoundingClientRect();
        const isRight = sliderRef.current.scrollWidth - bounds.width - 1 <
            sliderRef.current.scrollLeft && evt.deltaY > 0;
        if (Math.abs(prevDeltaY.current) === Math.abs(evt.deltaY) &&
            !isTrackPad.current &&
            (isLeft || isRight)) {
            mouseScrollCounter.current++;
            if (mouseScrollCounter.current >= MAX_MOUSE_SCROLL_COUNT) {
                isMouse.current = true;
            }
        }
        else {
            mouseScrollCounter.current = 0;
            isMouse.current = false;
        }
        if (Math.abs(prevDeltaY.current) + 1 < Math.abs(evt.deltaY) &&
            isTrackPad.current) {
            deltaCounter.current++;
            if (deltaCounter.current > 2 && !newScrollRegister.current) {
                allowNewScroll.current = true;
                newScrollRegister.current = true;
                deltaCounter.current = 0;
            }
        }
        else {
            deltaCounter.current = 0;
            newScrollRegister.current = false;
        }
        if (isMouse.current) {
            allowNewScroll.current = true;
        }
        prevDeltaY.current = evt.deltaY;
        if (isLeft && allowNewScroll.current) {
            return;
        }
        if (isRight && allowNewScroll.current) {
            return;
        }
        allowNewScroll.current = false;
        /* clearTimeout(allowNewScrollTimeout.current);
        allowNewScrollTimeout.current = window.setTimeout(onMouseAllow, 200); */
        if (sliderRef.current && evt.deltaY !== 0) {
            sliderRef.current.scrollLeft += evt.deltaY;
            evt.preventDefault();
        }
    };
    const onScrollEvent = (evt) => {
        if (!hasStepper)
            return;
        if (sliderRef.current) {
            scrollX.current = sliderRef.current.scrollLeft;
            checkCardState();
        }
    };
    const checkCardState = () => {
        requestAnimationFrame(handleCardState);
    };
    const handleCardState = () => {
        let changed = false;
        if (sliderRef.current) {
            if (detailsRef.current) {
                const opacity = Math.max(1 - sliderRef.current.scrollLeft / 20, 0);
                detailsRef.current.style.opacity = `${opacity}`;
                if (detailsButtonRef.current) {
                    if (opacity < 0.1) {
                        detailsButtonRef.current.style.pointerEvents = 'none';
                    }
                    else {
                        detailsButtonRef.current.style.pointerEvents = 'auto';
                    }
                }
            }
            if (leftGradientRef.current) {
                leftGradientRef.current.style.opacity = `${1 - Math.max(1 - sliderRef.current.scrollLeft / 80, 0)}`;
            }
        }
        const center = Math.floor((scrollX.current + cardWidth.current / 2) / cardWidth.current);
        if (centerCard.current !== center) {
            centerCard.current = center;
            changed = true;
        }
        const centerX = containerWidth.current.x +
            (containerWidth.current.width / 2 - cardWidth.current / 2);
        const hoverCardCoord = (mousePosition.current?.x ?? 0) - centerX + scrollX.current;
        const hoverCard = Math.max(0, Math.min(children.length - 1, Math.floor(hoverCardCoord / cardWidth.current)));
        if (activeCard.current !== hoverCard) {
            activeCard.current = hoverCard;
            changed = true;
        }
        if (changed) {
            setRender((x) => x + 1);
        }
    };
    const onMouseMove = (evt) => {
        mousePosition.current = { x: evt.pageX, y: evt.pageY };
        checkCardState();
        // setRender((x) => x + 1);
    };
    const onMouseLeave = () => {
        setTimeout(() => {
            mousePosition.current = null;
            checkCardState();
        });
    };
    const scrollToCard = (num) => {
        const pos = cardWidth.current * num;
        sliderRef.current?.scrollTo({
            behavior: 'smooth',
            left: pos,
        });
    };
    const hover = mousePosition.current ? activeCard.current : centerCard.current;
    return (_jsxs(_Fragment, { children: [hasStepper && (_jsx(Div, { className: "card-slider-stepper", delay: 1, noScale: true, children: _jsx(Stepper, { length: children.length, active: centerCard.current, hidden: false, highlight: hover, onClick: scrollToCard }) })), _jsx("div", { className: "card-slider", children: _jsxs("div", { className: "card-slider-scroll", children: [details ? (_jsx(Div, { className: "products-slider-details", delay: 2, noScale: true, children: _jsx(_Fragment, { children: _jsxs("div", { className: "products-slider-details-inside", ref: detailsRef, children: [details.text, details.button && (_jsxs(_Fragment, { children: [_jsx("div", { className: "separator" }), _jsx(Link, { to: details.button.url, "aria-label": `Visit ${linkToText(details.button.url)}`, children: _jsx("div", { className: "button", ref: detailsButtonRef, children: details.button.title }) })] }))] }) }) })) : null, _jsx("div", { className: `card-slider-scroll-container${startGap ? ' start-gap' : ''}`, ref: onSliderRef, onMouseMove: onMouseMove, onMouseEnter: onMouseMove, onMouseLeave: onMouseLeave, children: React.Children.map(children, (child, idx) => React.isValidElement(child)
                                ? React.cloneElement(child, {
                                    externalHover: idx === hover,
                                })
                                : child) })] }) })] }));
};
export default CardSlider;
